import { createAction } from '@reduxjs/toolkit';
import { type DemographicsDataProvider } from '~/store/demographics/demographics.types';
import { type DemographicsRegion } from '../demographics.repository';

export const demographicsListPremiumFetchDataRequest = createAction(
  'DEMOGRAPHICS_LIST_PREMIUM_FETCH_DATA_REQUEST'
);

export const demographicsListPremiumFetchDataStart = createAction(
  'DEMOGRAPHICS_LIST_PREMIUM_FETCH_DATA_START'
);

export const demographicsListPremiumFetchDataError = createAction(
  'DEMOGRAPHICS_LIST_PREMIUM_FETCH_DATA_ERROR'
);

export const demographicsListPremiumFetchDataSuccess = createAction(
  'DEMOGRAPHICS_LIST_PREMIUM_FETCH_DATA_SUCCESS',
  (providers: { [K in DemographicsDataProvider]: ReadonlyArray<DemographicsRegion> }) => ({
    payload: { providers },
  })
);
